import { type SearchPassengers } from "@trip/constants";

import { type TourConfig } from "./tours";

export function getBokunPricingCategoryKey(type: string) {
  switch (type) {
    case "ADULT":
      return "adults";
    case "CHILD":
      return "children";
    case "TEENAGER":
      return "teenagers";
    case "INFANT":
      return "infants";
    case "SENIOR":
      return "seniors";
    case "STUDENT":
      return "students";
    case "MILITARY":
      return "military";
    case "OTHER":
      return "other";
    case "GROUP":
      return "group";
    default: {
      return null;
    }
  }
}

export function getBokunPassengerCategoriesFromTripPassengers(
  searchPassengers: SearchPassengers,
  experiencePassengerCategories: TourConfig["passengerCategories"],
  minPassengers: number,
) {
  let remainingChildren = [...searchPassengers.children];

  function getPassengerCountForCategory(
    category: (typeof experiencePassengerCategories)[0],
  ) {
    if (category.type === "ADULT") {
      return Math.max(searchPassengers.adults, minPassengers);
    }

    if (category.type === "INFANT") {
      const count = remainingChildren.filter(({ age }) => age < 3).length;
      remainingChildren = remainingChildren.filter(({ age }) => age >= 3);
      return count;
    }

    if (category.type === "CHILD") {
      const minChildAge = experiencePassengerCategories.some(
        (c) => c.type === "INFANT",
      )
        ? 3
        : 0;
      const maxChildAge = experiencePassengerCategories.some(
        (c) => c.type === "TEENAGER",
      )
        ? 13
        : 18;
      const count = remainingChildren.filter(
        ({ age }) => age >= minChildAge && age < maxChildAge,
      ).length;
      remainingChildren = remainingChildren.filter(
        ({ age }) => age >= maxChildAge,
      );
      return count;
    }

    if (category.type === "TEENAGER") {
      const count = remainingChildren.filter(({ age }) => age >= 13).length;
      return count;
    }

    return 0;
  }

  return experiencePassengerCategories.map((category) => ({
    count: getPassengerCountForCategory(category),
    id: category.id,
  }));
}
